export function StepCard({
  step,
  title,
  description,
  active,
  completed,
  onClick,
  disabled,
}: {
  step: number;
  title: string;
  description: string;
  active?: boolean;
  completed?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}) {
  const containerBase =
    "flex h-full flex-col items-center rounded-xl md:rounded-2xl border px-3 py-4 md:px-6 md:py-8 text-center shadow-sm backdrop-blur-sm transition-colors";
  const containerTheme = active
    ? "border-terracotta-500 bg-terracotta-50 dark:border-terracotta-700 dark:bg-terracotta-900/20"
    : "border-terracotta-200/60 bg-white/80 dark:border-terracotta-800/40 dark:bg-terracotta-900/10";
  const badgeBase =
    "flex h-6 w-6 md:h-8 md:w-8 items-center justify-center rounded-full";
  const badgeTheme = completed
    ? "bg-terracotta-600 text-white"
    : active
    ? "bg-terracotta-500 text-white"
    : "bg-terracotta-100 text-terracotta-600 dark:bg-terracotta-900/20 dark:text-terracotta-400";
  const interactivity =
    onClick && !disabled
      ? "cursor-pointer hover:border-terracotta-400"
      : "cursor-default opacity-100";
  return (
    <div
      className={`${containerBase} ${containerTheme} ${interactivity}`}
      aria-current={active ? "step" : undefined}
      aria-disabled={disabled ? true : undefined}
      onClick={() => {
        if (onClick && !disabled) onClick();
      }}
    >
      <div className={`${badgeBase} ${badgeTheme}`}>{step}</div>
      <h3 className="mt-3 md:mt-8 font-semibold text-gray-900 dark:text-gray-100 text-sm md:text-base">
        {title}
      </h3>
      <p className="mt-2 md:mt-6 text-gray-600 dark:text-gray-400 text-xs md:text-sm hidden sm:block">
        {description}
      </p>
    </div>
  );
}

export default StepCard;
